import { Base } from "../../framework/base";
import { IRiskClassificationNode, RiskClassificationNode } from "./riskClassificationNode";

export interface IRiskClassificationNodes {
    nodes: IRiskClassificationNode[];
}

export class RiskClassificationNodes implements IRiskClassificationNodes {
    nodes: RiskClassificationNode[];

    constructor();
    constructor(obj: IRiskClassificationNodes);
    constructor(obj?: any) {
        this.nodes = Base.getTypedArray(obj.nodes, RiskClassificationNode);
    }
}